@let hasElements = ((layoutService.elements$ | async)?.length ?? 0) > 0;
<div class="search" [class.hidden]="hasElements">
  <app-search-contract-form [tableController]="contractsTable"></app-search-contract-form>
  <div class="new-contract-wrapper">
    <app-search-employee
      [formControl]="employeeControl"
      label="Employé existant"
    ></app-search-employee>
    @if (employeeControl.value) {
      <button mat-button [matMenuTriggerFor]="newForEmployee">
        <svg lucidePlus></svg>
        Prolongation / Avenant
      </button>
      <mat-menu #newForEmployee="matMenu">
        <button mat-menu-item (click)="openNewEmbaucheDialog(true)">
          <svg lucideCalendarSync class="menu-icon"></svg>
          Prolongation / renouvellement sans interruption
        </button>
        <button mat-menu-item (click)="openNewEmbaucheDialog(false)">
          <svg lucideCalendarPlus class="menu-icon"></svg>
          Prolongation / renouvellement avec interruption
        </button>
        <button mat-menu-item (click)="establishAmendment()">
          <svg lucideFilePenLine class="menu-icon"></svg>
          Avenant
        </button>
      </mat-menu>
    } @else {
      <button mat-button (click)="openNewEmbaucheDialog(false)">
        <svg lucidePlus></svg>
        Contrat
      </button>
    }
  </div>

  <app-contracts-table
    (editContract)="onEditContract($event)"
    (editSocialSecurity)="onEditSocialSecurity($event)"
  ></app-contracts-table>
</div>

@if (hasElements) {
  <app-contract-layout></app-contract-layout>
}
